<template>
    <div class="all-height">
        <el-main class="all-height">
            <el-row :gutter="20" class="all-height">
                <el-col :span="5" class="all-height">
                    <div>
                        <div class="select-box" slot="reference">
                            <span>供应商信息</span>
                        </div>
                    </div>
                    <div class="input-show">
                        <input type="text" placeholder="供应商编码或名称"/>
                        <i class="el-icon-search"></i>
                    </div>
                    <div class="table-show">
                        <el-row>
                            <el-col :span="12"><span>供应商编码</span></el-col>
                            <el-col :span="12"><span>供应商名称</span></el-col>
                        </el-row>
                        <el-table :data="orderData" height="calc(100% - 100px)"  :show-header="false">
                            <el-table-column property="date" align="center"></el-table-column>
                            <el-table-column property="orderNo" align="center"></el-table-column>
                        </el-table>
                        <div class="page-show">
                            <el-pagination
                                    small
                                    layout="prev, pager, next"
                                    :total="50">
                            </el-pagination>
                        </div>
                    </div>
                </el-col>
                <el-col :span="19" class="all-height">
                    <div class="all-height">
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-button plain>添加</el-button>
                                <el-button plain>编辑</el-button>
                                <el-button plain>删除</el-button>
                            </el-col>
                            <el-col :span="4">
                                <el-button plain>过期替换</el-button>
                            </el-col>
                            <el-col :span="14">
                                <div style="position: absolute; bottom: 0">
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-select size="mini" placeholder="选择分类" value="" default-first-option>
                                                <el-option label="选择一" value="1"></el-option>
                                                <el-option label="选择二" value="2"></el-option>
                                                <el-option label="选择三" value="3"></el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-select size="mini" placeholder="证件类型" value="">
                                                <el-option label="选择一" value="1"></el-option>
                                                <el-option label="选择二" value="2"></el-option>
                                                <el-option label="选择三" value="3"></el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-select size="mini" placeholder="全部" value="">
                                                <el-option label="选择一" value="1"></el-option>
                                                <el-option label="选择二" value="2"></el-option>
                                                <el-option label="选择三" value="3"></el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                        <div class="table-box">
                            <el-table :data="orderInfoData" height="calc(100% - 55px)"
                                      :header-cell-style="{background:'#4885CA', color: 'white'}">
                                <el-table-column property="date" label="状态" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="是否有效" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="资质类别" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="资质文件名称" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="证件编号" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="颁发机构" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="生效日期" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="失效日期" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="文件名称" header-align="center" align="center">
                                </el-table-column>
                                <el-table-column property="date" label="备注" header-align="center" align="center">
                                </el-table-column>
                            </el-table>
                            <div class="table-page">
                                <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="current"
                                        :page-sizes="[100, 200, 300, 400]"
                                        :page-size="100"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="400">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script>
    export default {
        name: 'credentials',
        data() {
            return {
                current: 1,
                companyData: [
                    {companyId: 12234,name: '卫华集团'},
                    {companyId: 12234,name: '河南卫华重型机械股份有限公司'}
                ],
                orderData: [
                    {date: '2020-06-14',orderNo: '12353211'},
                    {date: '2020-06-16',orderNo: '12353211'},
                    {date: '2020-06-17',orderNo: '12332211'},
                    {date: '2020-06-18',orderNo: '12355211'},
                    {date: '2020-06-19',orderNo: '12123311'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},
                    {date: '2020-06-20',orderNo: '12353285'},

                ],
                orderInfoData: [
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},
                    {orderNo: 'WH213',company: '卫华集团', address: '河南新乡', date: '2020-07-13'},

                ]
            }
        },
        methods: {
            handleSizeChange() {
            },
            handleCurrentChange() {
            }
        }
    };
</script>

<style scoped>
    .select-box {
        background-color: #4885CA;
        color: white;
        height: 50px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .select-box span {
        margin-right: 10px;
    }
    .select-box i {
        line-height: 21px;
    }
    .input-show {
        height: 50px;
        position: relative;
    }
    .input-show input {
        width: 100%;
        height: 100%;
        border: 0;
        outline: none;
        font-size: 16px;
        text-align: center;
    }
    .input-show i {
        width: 30px;
        height: 30px;
        text-align: center;
        font-size: 24px;
        color: #8E8D8D;
        line-height: 30px;
        display: block;
        position: absolute;
        right: 10px;
        top: calc(50% - 15px);
        cursor: pointer;
    }
    .input-show i:hover {
        color: #4885CA;
    }
    .table-show {
        height: calc(100% - 101px);
        border-top: 1px solid #D9D4D4;
        background-color: white;
        position: relative;
    }
    .table-show .el-row {
        padding: 12px 0;
    }
    .table-show .el-col {
        text-align: center;
    }
    .table-show .el-col:first-child {
        border-right: 1px solid #D9D4D4;
    }
    .page-show,.table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
    .table-box {
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 45px);
    }
</style>
